export default {
  "content": "<path fill=\"#1371C8\" fill-rule=\"evenodd\" d=\"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm6.579 7.477a.75.75 0 10-1.158-.954l-6.475 7.863L7.53 11.97a.75.75 0 00-1.06 1.06l4 4a.75.75 0 001.109-.053l7-8.5z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};